import { MatchBookNowCard, MatchDateInfo } from "./MatchBookNowCard";
import EventDetailContent from "./tabs/EventDetailContent";

export default MatchBookNowCard;

export { MatchDateInfo, EventDetailContent };
